import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.25065 15.834C6.90343 15.834 5.74718 15.3965 4.7819 14.5215C3.81662 13.6465 3.33398 12.5562 3.33398 11.2507C3.33398 9.9451 3.81662 8.85482 4.7819 7.97982C5.74718 7.10482 6.90343 6.66732 8.25065 6.66732H13.5007L11.334 4.50065L12.5007 3.33398L16.6673 7.50065L12.5007 11.6673L11.334 10.5007L13.5007 8.33398H8.25065C7.37565 8.33398 6.61523 8.61176 5.9694 9.16732C5.32357 9.72287 5.00065 10.4173 5.00065 11.2507C5.00065 12.084 5.32357 12.7784 5.9694 13.334C6.61523 13.8895 7.37565 14.1673 8.25065 14.1673H14.1673V15.834H8.25065Z",
		fill: "black",
		fillOpacity: .6
	})]
});
const ForwardRef = forwardRef(SvgRedo);
export { ForwardRef as ReactComponent };
